import { OUR_INDUSTRIES_DATA } from "const/data-solution";
import Image from "next/image";
import Container from "../common/Container";
import Title from "../common/Title";

const OurIndustries = () => (
  <Container large className="pb-20 md:pb-40">
    <Title
      description="When you decide to work with ultroNeous, we do honor the
  responsibility of taking care of your project. Our unwavering
  commitment and drive for innovation balances the performance with
  creativity."
      className="text-primary-black"
      descriptionClass="text-base text-primary-black text-center md:px-64 font-light pb-10 md:pb-24 font-light md:font-medium"
      subTitle="Industries We Serve"
      subTitleClass="text-4xl md:text-6xl text-primary-black text-center mb-4 xl:pb-2"
    />
    <div className="border border-solid border-r-0 border-l-0 border-b-0 border-gray-500/30">
      {OUR_INDUSTRIES_DATA.map((value) => (
        <div
          key={value.id}
          className="flex flex-col lg:flex-row relative py-7 md:py-16 md:px-8 group md:h-[360px] border border-solid border-r-0 border-l-0 border-t-0 border-gray-500/30"
        >
          <div className="w-full lg:w-7/12">
            <h3 className="text-primary-black mb-4 text-xl md:text-4xl font-medium">
              <span>{value.title}</span>
            </h3>
            <p className="text-primary-black text-base text-justify pb-6 lg:pr-12 lg:mr-12">
              <span>{value.description}</span>
            </p>
            <div className="flex flex-wrap gap-4 lg:gap-6">
              {value.links.map((ele) => (
                <div key={ele.linkText}>
                  <h4 className="fw-light text-lg md:text-xl">
                    <span>{ele.linkText}</span>
                  </h4>
                </div>
              ))}
            </div>
          </div>
          <div className="col-5 hidden md:block">
            <div className="fs-0 absolute top-0 group-hover:visible invisible -rotate-2 right-8">
              <Image alt={value.alt} height={348} src={value.src} width={510} />
            </div>
          </div>
        </div>
      ))}
    </div>
  </Container>
);

export default OurIndustries;
